export const lngs = {
    fi: { suffix: 'Fi', langcode: 'fi', nativeName: 'Suomi', alpha3: ['fin',] },
    sv: { suffix: 'Sv', langcode: 'sv', nativeName: 'Svenska', alpha3: ['swe',] },
    en: { suffix: 'En', langcode: 'en', nativeName: 'English', alpha3: ['gbr', 'usa'] },
};